import React, { Component } from 'react';
import * as globals from '../globals';
import logo from '../img/whitemapperlogo.png';
// import '../style/Footer.scss';

class Footer extends Component {
  render() {
    return (
      <div className="Footer wrap">
        <div>
          <a href={globals.dashURL}>Add your practice to the mapper</a>
        </div>
        <div style={{ textAlign: 'center' }}>
          <a href="https://www.dpcfrontier.com/frequently-asked-questions">
            Frequently Asked Questions
          </a>
          <br />
          <a href="https://www.dpcfrontier.com/disclaimer">Disclaimer</a>
          <br />
          <a href="https://www.dpcfrontier.com/termsprivacy">Terms/ Privacy</a>
          <br />
          <br />
          <p style={{ textAlign: 'center' }}>
            <small>
              Founded by Phil Eskew.
              <br />
              Copyright © 2018 by DPC Frontier, LLC
              <br /> All rights reserved.
            </small>
          </p>
        </div>
        <a href={globals.mapperURL} className="clickable">
          <img
            className="logo"
            src={logo}
            alt="DPC Frontier logo"
            style={{ width: '100px' }}
          />
        </a>
      </div>
    );
  }
}

export default Footer;
